/**
 * Appels de « Mes signalements » (décision 177) : tout compte, ses propres
 * signalements seulement — le serveur tire l'auteur du jeton.
 */
import {
  schemaMesSignalementsNonLus,
  schemaMonSignalement,
  schemaPageMesSignalements,
  type MonSignalement,
  type PageMesSignalements,
  type Pagination,
} from '@afs/shared'
import { requete } from '../api/client.js'

export const CHEMIN_MES_SIGNALEMENTS = '/mes-signalements'

export const clesMesSignalements = {
  tout: ['mes-signalements'] as const,
  liste: (pagination: Pagination) => [...clesMesSignalements.tout, 'liste', pagination] as const,
  nonLus: () => [...clesMesSignalements.tout, 'non-lus'] as const,
}

export function listerMesSignalements({ page, limite }: Pagination): Promise<PageMesSignalements> {
  return requete(`/signalements/miens?page=${String(page)}&limite=${String(limite)}`, {
    schema: schemaPageMesSignalements,
  })
}

export async function compterMesSignalementsNonLus(): Promise<number> {
  return (await requete('/signalements/miens/non-lus', { schema: schemaMesSignalementsNonLus }))
    .nombre
}

export function marquerMonSignalementLu(id: string): Promise<MonSignalement> {
  return requete(`/signalements/miens/${id}/lu`, { methode: 'POST', schema: schemaMonSignalement })
}
